import { combineReducers, Reducer } from "@reduxjs/toolkit";
import { configReducer as config, generalReducer as general } from "../../packages/app";
import { reducer as authentication } from "../../packages/authentication";
import { reducer as checkoutReducer } from "../../packages/checkout";
import disclaimerReducer from "../../packages/checkout/state/reducers/disclaimerReducer";
import { reducer as esimReducer } from "../../packages/esim";
import { reducer as fwaReducer } from "../../packages/fwa";
import { reducer as teliaPlayReducer } from "../../packages/telia-play";
import { reducer as loadingReducer } from "../../packages/loading";
import { reducer as navigationReducer } from "../../packages/navigation";
import { reducer as onboardingReducer } from "../../packages/onboardingB2B";
import { reducer as pickupPointReducer } from "../../packages/pickup-points";
import { reducer as prepaidReducer } from "../../packages/prepaid";
import { reducer as retailerReducer } from "../../packages/retailer";
import { reducer as shopPickerReducer } from "../../packages/shop-picker";
import { reducer as subscriptionListingReducer } from "../../packages/subscription-listing";
import { reducer as updatePortingDateReducer } from "../../packages/update-porting-date";
import { reducer as voucherReducer } from "../../packages/voucher";
import { reducer as webdealReducer } from "../../packages/webdeals";

export const error: Reducer = combineReducers({
    error: (state = {}) => state,
    general,
    config,
    authentication,
    navigation: navigationReducer,
});

export const checkout: Reducer = combineReducers({
    general,
    config,
    authentication,
    loading: loadingReducer,
    navigation: navigationReducer,
    broadband: (state = {}) => state,
    checkout: checkoutReducer,
    subscriptionListing: subscriptionListingReducer,
    pickupPoint: pickupPointReducer,
    webdeals: webdealReducer,
    modals: (state = {}) => state,
    shopAvailability: shopPickerReducer,
    esim: esimReducer,
    voucher: voucherReducer,
    queue: (state = {}) => state,
    test: (state = {}) => state,
    updatePortingDate: updatePortingDateReducer,
    fwa: fwaReducer,
    teliaPlay: teliaPlayReducer,
    prepaid: prepaidReducer,
    disclaimers: disclaimerReducer,
    onboarding: onboardingReducer,
    retailer: retailerReducer,
    dynamicPages: (state = []) => state,
});
